import { useState } from 'react';
/**
 * MUI's suggested pattern for handling the open/close state of popups is to
 * store the anchorEl ref inside of a piece of state instead of inside a ref
 * object.
 *
 * This hook makes doing so simpler by providing a click handler to store the
 * ref, a close function, an isOpen boolean, and storing the element in a
 * strongly typed fashion.
 */
export function useAnchorEl() {
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const close = () => setAnchorEl(null);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };
    return {
        /** Pass to the `anchorEl` prop of the popup */
        anchorEl,
        /** Pass to the `open` prop of the popup */
        isOpen,
        /** Pass to the `onClose` handler of the popup */
        close,
        /** Pass to the `onClick` handler of the button that should open the popup */
        handleClick,
        /**
         * Convenience object for spreading props over a `<Menu>` if you don't
         * want to pass them all individually every time.
         */
        menuProps: {
            open: isOpen,
            onClose: close,
            onClick: close,
            anchorEl: anchorEl,
        },
    };
}
